export class InvalidAccessTokenError extends Error {

    constructor(message: string) {
        super(message);
        this.name = 'InvalidAccessTokenError';

        Object.setPrototypeOf(this, InvalidAccessTokenError.prototype);
    }
}
